import { useState } from "react";
import ApplicationDetails from "../ApplicationDetails/AplicationDetails";
import { useTranslation } from "react-i18next";

export function ApplicationDetailsList({
  list,
  viewMode,
  activeId,
  errors,
  onChange,
  managers
}) {
  const [showAll, setShowAll] = useState(false);
  const { t } = useTranslation();

  return (
    <>
      <div>
        {showAll &&
          list?.map((applicationDetail) => (
            <div>
              <hr></hr>
              <ApplicationDetails
                applicationDetail={applicationDetail}
                viewMode={applicationDetail.locked || viewMode}
                errors={errors ? errors : {}}
                onChange={onChange}
                managers={managers}
                active={activeId === applicationDetail.id}
              />
            </div>
          ))}

        {!showAll && (
          <div>
            <hr></hr>
            {list
              ?.filter((x) => x.id === activeId)
              .map((applicationDetail) => (
                <ApplicationDetails
                  applicationDetail={applicationDetail}
                  viewMode={applicationDetail.locked || viewMode}
                  errors={errors ? errors : {}}
                  onChange={onChange}
                  managers={managers}
                  active={true}
                />
              ))}
          </div>
        )}
      </div>
      <div className="add-section" onClick={() => setShowAll(!showAll)}>
        {showAll ? t("show less") : t("show more...")}
      </div>
    </>
  );
}
